import TaskItem from '@tiptap/extension-task-item'

/**
 * Our customized variant of the official TaskItem extension.
 */
export const CustomTaskItem = TaskItem.extend({
  /**
   * Override `renderHTML()`, which is called by preview and static rendererer.
   */
  renderHTML({ node, HTMLAttributes }) {
    const originalHTML = this.parent?.({ node, HTMLAttributes })

    // If undefined, return fallback structure
    if (!originalHTML || !Array.isArray(originalHTML)) {
      return ['li', HTMLAttributes, 0]
    }

    const labelElmSpec = originalHTML[2] // Get label element

    if (Array.isArray(labelElmSpec)) {
      const inputElmSpec = labelElmSpec[1] // Get input element

      if (Array.isArray(inputElmSpec)) {
        const inputElmAttrs = inputElmSpec[1] // Get input element attributes

        if (
          inputElmAttrs &&
          typeof inputElmAttrs === 'object' &&
          !Array.isArray(inputElmAttrs)
        ) {
          inputElmAttrs.disabled = true // Inject `disabled` attribute to disable interactivity
        }
      }
    }

    return originalHTML
  },

  /**
   * Override `addNodeView()`, which is called by the live Tiptap editor.
   *
   * @remarks The original TaskItem extension is pure vanilla JS and is thus safe for us
   * to override like this. If it was written in React, this could introduce
   * sync bugs and memory leaks.
   *
   * @see https://github.com/ueberdosis/tiptap/blob/main/packages/extension-list/src/task-item/task-item.ts#L189
   */
  addNodeView() {
    return (props) => {
      const parentRenderer = this.parent?.()

      if (!parentRenderer) {
        return {
          dom: document.createElement('li'),
          contentDOM: document.createElement('span'),
        }
      }

      const result = parentRenderer(props)

      if (result && result.dom) {
        const input = result.dom.querySelector('input[type="checkbox"]')
        if (input) {
          input.setAttribute('tabindex', '-1') // Inject `tabIndex` attribute to prevent tab focus for inputs
        }
      }

      return result
    }
  },
})
